import { SETTINGS_PAGES } from 'src/pages/settings/settings.constants';

export const COMMON_PAGE_OPTIONS = {
  edit: 'edit',
  create: 'create',
};

export const DEFAULT_ITEM_TO_DELETE = {
  _id: '',
  name: '',
  removeKey: 0,
};

export const COMMON_PAGE_TYPES_DATA = {
  [SETTINGS_PAGES.absence]: {
    title: 'settings:companySettings.labels.absence',
    addBtn: 'settings:companySettings.buttons.addNewReason',
    infoLabel: 'settings:companySettings.labels.absenceReasons',
    formItemLabel: 'settings:companySettings.labels.absenceReasonName',
    formListName: 'absences',
    placeholder: 'settings:companySettings.labels.dayOff',
  },
  [SETTINGS_PAGES.documentsLabels]: {
    title: 'settings:documentsLabels.labelsForDocuments',
    addBtn: 'settings:documentsLabels.buttons.addNewLabel',
    infoLabel: 'settings:documentsLabels.availableLabels',
    formItemLabel: 'settings:documentsLabels.labelsName',
    formListName: 'labels',
    placeholder: 'settings:documentsLabels.paychecks',
  },
};
